import "./contact.css";
import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

function RevealOnScroll({ children, delay = 0 }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, ease: "easeOut", delay }}
    >
      {children}
    </motion.div>
  );
}

function ContactUs() {
  const pageVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0, transition: { duration: 1 } },
    exit: { opacity: 0, y: -20, transition: { duration: 1 } },
  };
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="contact-container">
        <div>
          <img
            src="https://i.imgur.com/ioYLlON.jpeg"
            alt=""
            className="contact-img"
          />
        </div>
        <div className="contact-info">
          <RevealOnScroll>
            <div className="contact-info-in">
              <div>
                <h1 className="contact-h1">CONTACT</h1>
              </div>
              <div>
                <h5>Address</h5>
                <p>192 Main St, Ridgefield Park, NJ 07660</p>
              </div>
              <div>
                <h5>Email Address</h5>
                <p><a href="mailto:info@cafevista.management" className="emailto">info@cafevista.management</a></p>
              </div>
              <div>
                <h5>Phone Number</h5>
                <p>201-853-9444</p>
              </div>
              <div>
                <h5>Follow</h5>
                <p><a href="https://www.instagram.com/cafevistaridgefieldpark/" className="emailto" target="_blank">@cafevistaridgefieldpark</a></p>
              </div>
            </div>
          </RevealOnScroll>
        </div>
      </div>
    </motion.div>
  );
}

export default ContactUs;
